import React from "react";
import ModeBar from "../ModeBar/ModeBar";
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import "./NavigationBar.css";
import Presentation from "../Presentation/Presentation";

const NavigationBar = () => {

    // functions related to the present button should probably go here

    return (
        // navigation bar
        <nav id="navbar">
            <div className="left-nav">
                <h1 id="nameplate"><strong>Figma</strong>Lite</h1>
                <ModeBar />
            </div>
            <Popup trigger={<button type="button" id="present-button"><h2>Present</h2></button>} modal>
                <Presentation/>
            </Popup>
        </nav>
    )

}

export default NavigationBar;